module.exports = __webpack_public_path__ + "media/images/game/doprava-9e3cca0ecd17e8763f32326a1bebc221.png";